export default __webpack_public_path__ + "static/media/blazed_collection_banner.0eea4391.jpg";